export default "__VITE_ASSET__CSzy36Gr__"